import { Record } from '../transit'

const Attender = Record({
  _id: '',
  firstName: '',
  lastName: '',
  name: '',
  birthdate: '',
  gender: '',
  sign: '',
  phoneNumber: ''
}, 'attender')

export default Attender



// WEBPACK FOOTER //
// ./src/common/attendances/Attender.js